var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ 'd-flex align-items-center': !_vm.inline }},[_vm._t("default"),(_vm.isStaff && _vm.is_help_reference_enabled)?_c('HelpReference',{class:{ 'd-flex align-items-center': !_vm.inline },attrs:{"identifier":_vm.identifier}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }